var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckcircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/checkcircle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 18.3308C14.6683 18.3308 18.25 14.7491 18.25 10.3308C18.25 5.91253 14.6683 2.33081 10.25 2.33081C5.83172 2.33081 2.25 5.91253 2.25 10.3308C2.25 14.7491 5.83172 18.3308 10.25 18.3308ZM14.1066 8.52194C14.3502 8.18695 14.2761 7.71789 13.9411 7.47426C13.6061 7.23063 13.1371 7.30469 12.8934 7.63968L9.40969 12.4298L7.53033 10.5505C7.23744 10.2576 6.76256 10.2576 6.46967 10.5505C6.17678 10.8434 6.17678 11.3182 6.46967 11.6111L8.96967 14.1111C9.12477 14.2662 9.33999 14.3457 9.55867 14.3285C9.77734 14.3114 9.97754 14.1993 10.1066 14.0219L14.1066 8.52194Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckcircle);
export default __webpack_public_path__ + "static/media/checkcircle.b132c1bae75da8d42fb6e18567992829.svg";
export { ForwardRef as ReactComponent };